/** The gaps the copilot model can pick for its Grid. apps/react/vite.config.ts imports this to build the sprinkles safelist, so this module must stay free of runtime imports. */
export const COPILOT_GRID_GAPS = ['100', '200', '300', '400'] as const;

export type CopilotGridGap = (typeof COPILOT_GRID_GAPS)[number];
